export default __webpack_public_path__ + "static/media/Privacy-Policy.105a88a7.jpg";